import { Component, Input, OnInit } from '@angular/core';
import { CertificateNote_Interface, Empty_CertificateNote_Interface } from 'src/app/Interface/CertificateNote_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CertificateNoteService } from 'src/app/Service/CertificateNote/CertificateNote.service';

@Component({
  selector: 'app-DataEntityCertificateNote',
  templateUrl: './DataEntityCertificateNote.component.html',
  styleUrls: ['./DataEntityCertificateNote.component.css']
})
export class DataEntityCertificateNoteComponent implements OnInit {

  @Input() inner_Calibration_Device_Id:number=0

  Token: String = ''
  Filter_Dsc: String = ''
  Seleted_Note_Id: String = ''
  constructor(
    private CertificateNote_Service: CertificateNoteService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Read_Data_CertificateNote() 
  }


  InProccessing: boolean = false
  DataList_CertificateNote: Array<CertificateNote_Interface> = []
  Read_Data_CertificateNote() {
    this.InProccessing = true
    this.CertificateNote_Service.GetActiveList(this.Token).subscribe(
      data => {
        this.InProccessing = false
        this.DataList_CertificateNote = data
        this.Read_Data_CertificateNote_Selected()
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  SubmitCertificate() {
    this.CertificateNote_Service.SubmitCertificate(this.inner_Calibration_Device_Id, Number(this.Seleted_Note_Id), this.Token).subscribe(
      data => {
        if (data.id == 0) {
          this.Alertify_Service.SuccessMessage("The information was saved successfully.")
          this.Read_Data_CertificateNote_Selected()
        }
        else if (data.id == -2){
          this.Alertify_Service.ErrorMessage("Registration is not permitted.")
        }
        else{
          this.Alertify_Service.ErrorMessage("The selected note already exists in the list.")
        }
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  DeleteCertificateNote(id:number) {
    this.CertificateNote_Service.DeleteCertificate(this.inner_Calibration_Device_Id, id, this.Token).subscribe(
      data => {
        if (data.id == 0) {
          this.Alertify_Service.SuccessMessage("The information was deleted successfully.")
          this.Read_Data_CertificateNote_Selected()
        }
        else if (data.id == -2){
          this.Alertify_Service.ErrorMessage("Registration is not permitted.")
        }
        else{
          this.Alertify_Service.ErrorMessage("The selected note already exists in the list.")
        }
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }

  Selected_DataList_CertificateNote: Array<CertificateNote_Interface> = []
  Read_Data_CertificateNote_Selected() {
    this.InProccessing = true
    this.CertificateNote_Service.GetActiveListCertificate(this.Token,this.inner_Calibration_Device_Id).subscribe(
      data => {
        this.InProccessing = false
        this.Selected_DataList_CertificateNote = data
      }, error => {
        localStorage.clear()
        location.reload();
      }
    )
  }


  Change_Filter_title(){
    this.Seleted_Note_Id=''
  }

}
